/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/notifications'),
    component: () => import('../settings/SettingsWrapper.vue'),
    children: [
      {
        path: '',
        name: 'notifications_index',
        component: () => import('./components/NotificationsView.vue'),
        meta: {
          permissions: ['administrator', 'agent', 'custom_role'],
        },
      },
    ],
  },
];
